import { useState } from "react";
import { useSiteBrand } from "./brand";
import { DEFAULT_INFO } from "./content";
import { GlassCard, SectionHeader } from "./ui";

export const LeadershipSection = ({ leaders }) => {
  const [expanded, setExpanded] = useState({});
  const brand = useSiteBrand();
  const fallback = brand.isDefault ? DEFAULT_INFO.leadership : [];
  const list = Array.isArray(leaders) && leaders.length ? leaders : fallback;
  if (!list.length) return null;

  return (
    <section id="lideranca" className="public-section public-leadership-section py-10 sm:py-14 scroll-mt-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          k="Liderança"
          title="Pessoas que servem com propósito"
          desc="Conheça quem conduz, organiza e serve a nossa comunidade com fé, responsabilidade e dedicação."
        />
        <div className="public-leadership-grid grid gap-6 lg:grid-cols-2">
          {list.map((leader) => {
            const paragraphs = String(leader.bio || "")
              .split(/\n{2,}/)
              .map((p) => p.trim())
              .filter(Boolean);
            return (
            <GlassCard key={leader.id || leader.name} className="overflow-hidden border-white dark:border-slate-900/80 bg-white dark:bg-slate-900/70 shadow-sm">
              <div className="grid sm:grid-cols-[180px_1fr]">
                <div className="aspect-[4/5] sm:aspect-auto sm:h-full min-h-[260px] bg-slate-100 dark:bg-slate-800">
                  {leader.image ? (
                    <img src={leader.image} alt={leader.name} className="h-full w-full object-cover object-[50%_25%] sm:object-top" loading="lazy" decoding="async" />
                  ) : (
                    <div className="flex h-full items-center justify-center text-4xl text-slate-400 dark:text-slate-500">👤</div>
                  )}
                </div>
                <div className="p-5 sm:p-6">
                  <p className="text-xs font-bold uppercase tracking-[0.16em] text-indigo-600 dark:text-indigo-300">{leader.role}</p>
                  <h3 className="mt-2 text-2xl font-extrabold tracking-tight text-slate-900 dark:text-slate-100">{leader.name}</h3>
                  <div className="mt-4 space-y-3 text-sm leading-relaxed text-slate-600 dark:text-slate-400">
                    {paragraphs.map((paragraph, index) => (
                      <p key={paragraph} className={index === 0 || expanded[leader.name] ? "block" : "hidden sm:block"}>
                        {paragraph}
                      </p>
                    ))}
                  </div>
                  <button
                    type="button"
                    className="mt-4 inline-flex items-center rounded-full border border-indigo-200 dark:border-indigo-800/50 bg-indigo-50 dark:bg-indigo-950/40 px-3.5 py-2 text-sm font-bold text-indigo-700 dark:text-indigo-300 hover:bg-indigo-100 dark:hover:bg-indigo-900/40 sm:hidden"
                    onClick={() => setExpanded((prev) => ({ ...prev, [leader.name]: !prev[leader.name] }))}
                  >
                    {expanded[leader.name] ? "Mostrar resumo" : "Ler perfil completo"}
                  </button>
                </div>
              </div>
            </GlassCard>
            );
          })}
        </div>
      </div>
    </section>
  );
};
